import { render, staticRenderFns } from "./CrmResourceDropTree.vue?vue&type=template&id=66a224c0&"
import script from "./CrmResourceDropTree.vue?vue&type=script&lang=js&"
export * from "./CrmResourceDropTree.vue?vue&type=script&lang=js&"
import style0 from "./CrmResourceDropTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports